//  ============================================================================================================================================================
//  ===========================================================================================================================================================
/*!
* Copyright (c) 2018-present Cyclope.ai
* LICENSE file is in the root directory of this source tree.
* */

import * as Lodash from 'lodash';

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date du Jour ,
 * @function onDayUtils ;
 * @param {}
 * @return {string }
 */
export const onDayUtils = (): string => {
    const OptionForDayDate: any = {
        day: 'numeric',
        month: 'long',
        weekday: 'long',
        year: 'numeric'
    };
    const newDate: Date = new Date()
    let TheDay: string = newDate
        .toLocaleDateString('fr-FR', OptionForDayDate);
    TheDay = TheDay.charAt(0).toUpperCase() + TheDay.slice(1);
    return TheDay;
}

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * L'heure du Jour ,
 * @function onClockUtils
 * @param {  } 
 * @return { string }
 */
export const onClockUtils = (): any => {

    const today = new Date();
    let h: any = today.getHours();
    let m: any = today.getMinutes();
    let s: any = today.getSeconds();
    h = (h < 10) ? "0" + h : h;
    m = (m < 10) ? "0" + m : m;
    s = (s < 10) ? "0" + s : s;

    const time = h + ":" + m + ":" + s;

    return time;

}

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Interchanger les sources de video
 * @function onChangeSourceVideoImpact 
 * @param { any } event
 * @return { array }
 */

export const onChangeSourceAndTarget = (event: any): any => {

    const targetElement: any = document.querySelector("#largeImage");
    const SourceElement: any = event.target.parentElement;

    const target: any[] = [];
    const source: any[] = [];


    if (!Lodash.isEmpty(targetElement.children) || !Lodash.isEmpty(SourceElement.children)) {

        for (const j in  targetElement.children) {

            if (targetElement.children.hasOwnProperty(j)) {

                target.push(targetElement.children[j]);

            }

        }

        for (const i in  SourceElement.children) {

            if (SourceElement.children.hasOwnProperty(i)) {

                source.push(SourceElement.children[i]);

            }

        }

    }

    const targetSlice = target.slice();
    const sourceSlice = source.slice();

    return {

        sourceSlice,
        targetSlice,

    }
}

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Changement des sources au click de la souris
 * @function onChangeTargetIncident
 * @param { any } SourceElement 
 * @param { any } targetElement
 * @param { any } changeSource
 * @return { }
 */
export const onChangeTargetIncident = (SourceElement: any, targetElement: any, changeSource: any) => {

    const sourceTargetArray = [SourceElement, targetElement];

    sourceTargetArray.map((Elem) => {

        for (const key in Elem.children) {

            if (Elem.children.hasOwnProperty(key)) {

                if (Elem.children[0] !== "undefined") {

                    Elem.children[0].remove();

                }

            }

        }

    })


    for (const key in changeSource.sourceSlice) {

        if (changeSource.sourceSlice.hasOwnProperty(key)) {

            targetElement.appendChild(changeSource.sourceSlice[key]);
        }

    }
    for (const key in changeSource.targetSlice) {

        if (changeSource.targetSlice.hasOwnProperty(key)) {

            SourceElement.appendChild(changeSource.targetSlice[key]);

        }
    }
}
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Tranforme un object en tableau
 * @function transformObjectToArray  
 * @param { object } data
 * @return { array }
 */

export const transformObjectToArray = (data: object): any => {

    const Arr = [];

    for (const key in data) {

        if (data.hasOwnProperty(key)) {

            Arr.push(data[key]);

        }
    }
    return Arr;
}

// ============================================================================================================================================================
// 
/**
 * Création d'un objet avec  tableau unique 
 * @function createAnUniqueArrayFromObject
 * @param { any } Elem 
 * @param { string } string 
 * @return { any }
 */
export const createAnUniqueArrayFromObject = ( Elem: any): any => {
  
    
    if(!Lodash.isUndefined(Elem) && Lodash.isArray(Elem) && !Lodash.isEmpty(Elem)){

        const arr: string[] = [] ;

        
        for (let i = 0; i < Elem.length; i++ ){

            arr[i] = Elem[i].prod.image_url
    
        }
     
        return arr.filter((v: any,i: any) => arr.indexOf(v) === i);
        
    }

}

/**
 * Création d'un objet ppas
 * @function dynamicSortByTimeStamp
 * @param { any } Elem 
 * @return { any }
 */
export const dynamicSortByTimeStamp = (Elem: any): any => {

    if(Lodash.isArray(Elem) && !Lodash.isUndefined(Elem)){
        return Elem.sort((a: any,b: any) => (a['@timestamp'] > b['@timestamp']) ? 1 : ((b['@timestamp'] > a['@timestamp']) ? -1 : 0))
    }
}

/**
 * Création d'un objet ppas
 * @function filterScoreAndPredifClassif
 * @param { any } Elem 
 * @return { any }
 */
export const filterScoreAndPredifClassif = (Elem: any, paramClass: number ): any => {

    if(Lodash.isArray(Elem) && !Lodash.isUndefined(Elem)){
        return Elem.filter( (item: any) => Number(item.prod.score_classif*100) > 95)
                   .filter( (elem: any) => Number(elem.prod.pred_classif) === Number(paramClass))
    }
}
/**
 * Création d'un objet ppas
 * @function removeDuplicateObject
 * @param { any } Elem 
 * @param { string } string 
 * @return { any }
 */
export const removeDuplicateObject = ( Elem: any, action: string): any => {
  
    
    if(!Lodash.isUndefined(Elem) && Lodash.isArray(Elem) && !Lodash.isEmpty(Elem)){

      return Elem.reduce((unique: any,o: any) => {
    
        if(action ==="prod"){
            if(!unique.some((obj: any) => obj.prod.image_url === o.prod.image_url)){
                unique.push(o);
            }
        }else if(action ==="preprod"){
            if(!unique.some((obj: any) => obj.preprod.image_url === o.preprod.image_url)){
                unique.push(o);
            }
        }else if(action ==="timestamp"){
            if(!unique.some((obj: any) => obj['@timestamp'].split('.')[0] === o['@timestamp'].split('.')[0])){
                unique.push(o);
            }
        }
        return unique;
          
    },[]);
        
    }
}
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * La date au format Français
 * @function localDateFrSecondFormat
 * @param {any } date
 * @return { string }
 */
export const localDateFrSecondFormat = (date: any): any => {

    const FormatDate = new Date(date);
  
    const hours = FormatDate.getHours();
    const minutes = FormatDate.getMinutes();
    // const secondes = FormatDate.getSeconds();

    const h = (hours < 10) ? "0" + hours : hours;
    const m = (minutes < 10) ? "0" + minutes : minutes;
    // const s = (secondes < 10) ? "0" + secondes : secondes;

    let message = h + ":";
    
    message += m // + ":";
   // message += s + " ";

    return message;
}

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Overture de la popup d'information " datails de la caméra"
 * @function onOpenCameraInformation
 * @param {}
 * @return {}
 */
export const onOpenCameraInformation = (): void => {

    const modalCameraInformation: any = document.querySelector("#camera-details");

    if (modalCameraInformation !== null) {

        modalCameraInformation.style.display = "block";

    }
}
// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Ferméture de la popup d'information " datails de la caméra"
 * @function onCloseCameraInformation
 * @param {}
 * @return {}
 */
export const onCloseCameraInformation = (): void => {

    const modalCameraInformation: any = document.querySelector("#camera-details");

    if (modalCameraInformation !== null) {

        modalCameraInformation.style.display = "none";

    }
}
// ============================================================================================================================================================

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * @function isAuthenticated
 * @param { any } user
 * @return { boolean }
 */
export const isAuthenticated = (user: any) => !!user;

// ============================================================================================================================================================

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Création d'une clé ,stocké dans le locale storage
 * @function localStorageSetItem
 * @param { any} Token
 * @return {boolean}
 */
export const localStorageSetItem = (Token: any): any => {

    const key = "tollsense";

    return !localStorage.getItem(key) && localStorage.setItem(key, Token);

}


// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Destruction d'une clé
 * @function localStorageItem
 * @param {}
 * @return {}
 */

export const localStorageClear = (): void => {

    const key = "tollsense";
    localStorage.removeItem(key);
    localStorage.removeItem("menuactive");


}

// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Recherche d'une clé
 * @function localStorageIsKeyExist
 * @param {}
 * @return { boolean }
 */
export const localStorageIsKeyExist = (): boolean => {

    const key = "tollsense";

    return localStorage.getItem(key)?true: false;

}


// ============================================================================================================================================================
//  ===========================================================================================================================================================
/**
 * Fermer ou élargir le menu
 * @function hideShowmenu
 * @param {}
 * @return {}
 */
export const hideShowmenu = () => {
    
    const menu : any = document.querySelector("#menu");
    const main: any = document.querySelector("#main");
    const menuBurder : any = document.querySelector("#menu-burger");
   
  
    if(menuBurder !== null){
        //  left main
        const name = "left menu menuLeft ";
        const nameMain = "left main mainLeft";

        
        const nameRight = "left menu menuRight";
        const nameMainRight  = "left main mainRight";

        const arrMain = main.className.split(" ");
        const arrMenu = menu.className.split(" ");
        
        if(menu.classList.contains("menuRight") &&  main.classList.contains("mainRight")){
            if ((arrMenu.indexOf(name) === -1) && (arrMain.indexOf(nameMain) === -1) ) {
                menu.className  = name;
                main.className  = nameMain;
            }
        }else{
            if ((arrMenu.indexOf(nameRight) === -1) && (arrMain.indexOf(nameMainRight) === -1) ) {
                menu.className  = nameRight;
                main.className  = nameMainRight;
            }
        }

    }
}


/**
 * Fermer ou élargir le bouton du bas de la page
 * @function hideShowlayout
 * @param {}
 * @return {}
 */
export const hideShowlayout = () => {
    
    const menu : any = document.querySelector("#layoutFive");
    const CLassFive : any = document.querySelector("#seeCLass");

    if(menu !== null){
        //  left main
        const one = "layout-five layout-one animated slideInDown";
        const two = "layout-five layout-two animated slideInUp";

        const seeClass ="brc-tn btn-text animated fadeIn";
        const notSee = "not-see animated fadeOut"
       
        const arrMenu = menu.className.split(" ");
        const arrCLassFive = CLassFive.className.split(" ");
        
        if(menu.classList.contains("layout-one") ){
            if ((arrMenu.indexOf(one) === -1) && (arrCLassFive.indexOf(seeClass) === -1) ) {
                
                menu.className  = two;
                CLassFive.className  = notSee;

            }
        }else{
            if ((arrMenu.indexOf(two) === -1) || (arrCLassFive.indexOf(notSee) === -1)) {
                menu.className  = one;
                CLassFive.className  = seeClass;
            }
        }

    }
}


// WEBPACK FOOTER //
// ./src/root/utils/helpers/index.ts